'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dPerson from "./samples.-Person.js";
var $p;
/** @constructor */
function $c_Lsamples_Conditional$package$$anon$12(evaluator$12) {
  this.KT = null;
  this.KT = evaluator$12;
}
export { $c_Lsamples_Conditional$package$$anon$12 as $c_Lsamples_Conditional$package$$anon$12 };
$p = $c_Lsamples_Conditional$package$$anon$12.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Conditional$package$$anon$12;
/** @constructor */
function $h_Lsamples_Conditional$package$$anon$12() {
}
export { $h_Lsamples_Conditional$package$$anon$12 as $h_Lsamples_Conditional$package$$anon$12 };
$h_Lsamples_Conditional$package$$anon$12.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.KT.h();
  return ((v instanceof $j_samples$002e$002dPerson.$c_Lsamples_Person) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Conditional$package$$anon$12 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Conditional$package$$anon$12, "samples.Conditional$package$$anon$12", ({
  or: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Conditional$package$$anon$12 as $d_Lsamples_Conditional$package$$anon$12 };
